import React from 'react';
import '../styles/workingscheme.css';

const steps = [
  {
    icon: '🔍',
    title: 'Choose Your Exam',
    description: 'Browse our extensive catalog of professional and educational exams & certifications. Find the specific certification or test you need to prepare for.'
  },
  {
    icon: '🖥️',
    title: 'Practice with Simulations',
    description: 'Take realistic exam simulations that mirror the actual test environment, including timing, question formats, and difficulty levels.'
  },
  {
    icon: '📊',
    title: 'Track Your Progress',
    description: 'Review detailed analytics on your performance. Identify strengths and weaknesses to focus your study efforts where they matter most.'
  },
  {
    icon: '🏅',
    title: 'Master Your Exam',
    description: "With consistent practice and targeted improvements, you'll gain the confidence and knowledge needed to excel on exam day."
  }
];

const WorkingScheme = () => {
  return (
    <div className="working-scheme-container">
      <h2>How Poly Quizz Works</h2>
      <p className="subtitle">
        Our comprehensive platform makes exam preparation straightforward and effective. Follow these steps to maximize your chances of success.
      </p>
      <div className="steps-grid">
        {steps.map((step, index) => (
          <div className="step-card" key={index}>
            <div className="icon-circle">{step.icon}</div>
            <div className="step-number">{index + 1}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkingScheme;